import { Component, OnInit, Input, Output, EventEmitter, DoCheck, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import moment from 'moment';
import { MetricGame, MetricOptions } from 'src/app/gamification/command-center/models/metric-game';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { CvDialogService } from 'src/app/reusables/confirm-dialog/cv-dialog.service';
import { ValidationHelperService } from 'src/app/reusables/services/validation-helper.service';
import { cloneDeep } from 'lodash';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import { NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cv-games-configure',
  templateUrl: './games-configure.component.html',
  styleUrls: ['./games-configure.component.scss']
})
export class GamesConfigureComponent implements OnInit, DoCheck {
  @Input() game: any;
  @Input() isCxone: boolean = false;
  @Input() flowMode: string = 'create';

  @Output() saveSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelAddEdit: EventEmitter<void> = new EventEmitter<void>();
  @Output() previousView: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('scrollableContent') scrollableContent: ElementRef;


  gs: any = null;
  nameEditing: boolean = false;
  saveInProgress: boolean = false;
  oldSaveInProgress: boolean = null;
  metricSelectorOptions: any = {};
  metricSelectorComponentSource = null;
  metricSelectorLoading: boolean = false;
  preLoadMetricData: MetricGame = {};
  specialCharacters: RegExp = /[\\/!+<>?#&,%]/;
  rankingData: any;
  loading: boolean = false;

  constructor(
    private gamesService: GamesService,
    private navigationService: NavigationService,
    private validationHelper: ValidationHelperService,
    private dialogService: CvDialogService,
    private cdRef: ChangeDetectorRef,
    private cvLocalization: CVLocalizationService,
    private customDialogService: CvCustomDialogService,
  ) {
    this.gs = this.gamesService.data
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.scrollToTop();
  }

  ngDoCheck(): void {
    if ((this.oldSaveInProgress != this.saveInProgress)) {
      if (this.saveInProgress) {
        $("body").addClass("stopScrolling");
      } else {
        $("body").removeClass("stopScrolling");
      }

      this.oldSaveInProgress = this.saveInProgress;
    }
  }

  focusNameTextbox($event): void {
    this.nameEditing = true;
    setTimeout(() => {
      $($event.target).parents(".glGameNameContainer").find("input").focus();
    }, 1);
  }

  blurNameTextbox(): void {
    this.nameEditing = false;
  };

  validateGame() {
    let msg = (key, fallback) => {
      return this.gamesService.getValidationMessage(key, fallback);
    };

    this.validationHelper.validationInstance();

    if (this == null || this.gs == null || this.gs.modified == null || this.gs.modified.item == null) {
      this.validationHelper.addValidationError(msg("No_Game_Found", "No game found to save. Please try again."), true);
    }

    var game = this.gs.modified.item;
    this.validationHelper.test(game.underlyingRule.RuleName, { Required: msg("Game_Name_Required", "You haven't input a name for the game."), TestAs: 'String', failsValidation: true });

    if (this.gs.games.filter((game: any) => {
      return game.underlyingRule.RuleName.toUpperCase() === this.gs.modified.item.underlyingRule.RuleName.toUpperCase()
        && (game.underlyingRule.RuleID != this.gs.modified.item.underlyingRule.RuleID)
    }).length > 0) {
      //Duplicated Name
      this.validationHelper.addValidationError(msg("Game_Name_Duplicated", "The name of this game has already been taken."), true);
    }

    if (game.underlyingRule.RuleName.length > 50) {
      this.validationHelper.addValidationError(msg("Game_Name_Length", "The name of this game is too long."), true);
    }

    if ((/[\\/!+<>?#&,%]/).test(this.gs.modified.item.underlyingRule.RuleName)) {
      this.validationHelper.addValidationError(msg("Game_Invalid_Characters", "The following characters are not permitted: \ / ! + < > ? # & , %"), true);
    }

    if (!game.underlyingRule.RuleFolder) {
      this.validationHelper.addValidationError(msg("Folder_Name_Required", "You haven't select or type a folder for the game."), true);
    }

    //Folder name doesn't exist then create one in the backend 
    var FolderFound = this.gs.GameFolders.filter((f: any) => { return f.FolderData.FolderName.toUpperCase() === this.gs.modified.item.underlyingRule.RuleFolder.toUpperCase() });
    if (FolderFound.length == 0) {
      this.gs.modified.item.underlyingRule.FolderID = 0;
    }
    else { // Folder typed exists but needs ID
      this.gs.modified.item.underlyingRule.FolderID = FolderFound[0].FolderData.FolderID;
    }

    //Choose metric component
    if (!game.SelectedMetrics) {
      this.validationHelper.addValidationError(msg("Metric_Required", "A Metric is required for a game to run."), true);
    }

    //Qualifier
    if (game.QualifierLevels.leftNumber < 0 || game.QualifierLevels.rightNumber < 0) {
      const leftNumber = parseFloat(game.QualifierLevels.leftNumber);
      const rightNumber = parseFloat(game.QualifierLevels.rightNumber);
      if (game.QualifierLevels.comparerType === "3") {
        if (leftNumber < 0) {
          this.validationHelper.addValidationError(msg("Qualifier_Levels_Between_Left_Min", "The first value of the Qualifier must be equal to or greater than zero."), null);
        }
        if (rightNumber < 0) {
          this.validationHelper.addValidationError(msg("Qualifier_Levels_Between_Right_Min", "The second value of the Qualifier must be equal to or greater than zero."), null);
        }

      } else {
        if (leftNumber < 0) {
          this.validationHelper.addValidationError(msg("Qualifier_Levels_Min", "The value of the Qualifier Level must be equal to or greater than zero."), null);
        }
      }
    }

    //Validate Milestone Metrics only up and count type.
    if (game.underlyingRule?.GameType == 5 && game.SelectedMetrics && (game.SelectedMetrics[0]?.direction != 1 || game.SelectedMetrics[0]?.conversionType != "0")) {
      this.validationHelper.addValidationError(msg("Milestone_Metric_Message", "The selected metric is not an upward count metric and cannot be used in a Milestone game."), true);
    }

    //Validate metrics on Connect3 Positions
    if (game.underlyingRule.GameType == 6 || game.underlyingRule.GameType == 7) {
      for (let i = 0; i < game.Connect3Positions.length; i++) {
        if (game.Connect3Positions[i].metric == undefined || game.Connect3Positions[i].metric == null) {
          this.validationHelper.addValidationError(msg("Missing_Metrics", "Please, complete the GameBoard."), true);
        }
      }
    }

    //Rewards components            
    if (game.underlyingRule.GameType == 1) { //Multipier Madness
      if (game.MultiplierMadnessRewards == null)
        this.validationHelper.addValidationError(msg("Multiplier_Madness_No_Component", "Multiplier Madness section not found for this Multiplier Madness game."), true);
      else {
        var mmr = game.MultiplierMadnessRewards;
        this.validationHelper.test(mmr.coins,
          new this.validationHelper.ValidationExpressionBuilder()
            .MinValue(0, msg("Multiplier_Madness_Coins_Min", "Multiplier Madness Coin Reward must not be a negative number."))
            .MaxValue(9999999, msg("Multiplier_Madness_Coins_Max", "Coin Reward must contain 7 digits or fewer."))
            .DigitOnly(msg("Multiplier_Madness_Coins_Invalid", "Multiplier Madness Coin Reward must be a valid number."))
            .WholeNumberOnly(msg("Multiplier_Madness_Coins_Whole_Number", "Multiplier Madness Coin Reward must be a whole number."))
            .Build()
        );
        
        this.validationHelper.test(mmr.xp,
          new this.validationHelper.ValidationExpressionBuilder()
            .MinValue(0, msg("Multiplier_Madness_XP_Min", "Multiplier Madness XP field must not be a negative number."))
            .DigitOnly(msg("Multiplier_Madness_XP_Invalid", "Multiplier Madness XP field must be a valid number."))
            .WholeNumberOnly(msg("Multiplier_Madness_XP_Whole_Number", "Multiplier Madness XP field must be a whole number."))
            .Build()
        );

        //catch a case where the max payout isn't visible, but has a zero in place (edit flows cause this)
        if (!mmr.hasMaxCoins && mmr.maxCoinsPayout != null && mmr.maxCoinsPayout == 0)
          mmr.maxCoinsPayout = null;
        if (!mmr.hasMaxXP && mmr.maxXpPayout != null && mmr.maxXpPayout == 0)
          mmr.maxXpPayout = null;

        if (mmr.maxCoinsPayout != null)
          this.validationHelper.test(mmr.maxCoinsPayout,
            new this.validationHelper.ValidationExpressionBuilder()
              .MinValue(1, msg("Multiplier_Madness_Max_Coins_Min", "Max Coin Reward must be 1 or more, or should be removed."))
              .MaxValue(9999999, msg("Multiplier_Madness_Max_Coins_Max", "Max Coin Reward must contain 7 digits or fewer."))
              .DigitOnly(msg("Multiplier_Madness_Max_Coins_Invalid", "Max Coin Reward must be a valid number."))
              .WholeNumberOnly(msg("Multiplier_Madness_Max_Coins_Whole_Number", "Max Coin Reward must be a whole number."))
              .Build()
          );
        if (mmr.maxXpPayout != null)
          this.validationHelper.test(mmr.maxXpPayout,
            new this.validationHelper.ValidationExpressionBuilder()
              .MinValue(1, msg("Multiplier_Madness_Max_XP_Min", "Maximum XP Payout field must be 1 or more, or should be removed."))
              .DigitOnly(msg("Multiplier_Madness_Max_XP_Invalid", "Maximum XP Payout field must be a valid number."))
              .WholeNumberOnly(msg("Multiplier_Madness_Max_XP_Whole_Number", "Maximum XP Payout field must be a whole number."))
              .Build()
          );

        if (mmr.coins == "0" && mmr.xp == "0") // && mmr.currency == "0")
          this.validationHelper.addValidationError(msg("Multiplier_Madness_No_Reward", "Multiplier Madness games must have a non-zero reward available."), true);
      }
    } //End Multiplier Madness validation

    if (game.underlyingRule.GameType == 2) { //Top Dog
      if (game.TopDogRewards == null) {
        this.validationHelper.addValidationError(msg("Top_Dog_No_Component", "No Top Dog section found for this Top Dog game."), true);
      }
      else {
        game.TopDogRewards.forEach(element => {
          this.validationHelper.test(element.Coins.rewardValue,
            new this.validationHelper.ValidationExpressionBuilder()
              .MinValue(0, msg("Top_Dog_Coins_Min", "Coin Reward on Top Dog levels must be positive numbers."))
              .MaxValue(9999999, msg("Top_Dog_Coins_Max", "Coin Reward on the Top Dog level must contain 7 digits or fewer."))
              .DigitOnly(msg("Top_Dog_Coins_Invalid", "Coin Reward on Top Dog levels must be valid numbers."))
              .WholeNumberOnly(msg("Top_Dog_Coins_Whole_Number", "Coin Reward on Top Dog levels must be whole numbers."))
              .Build()
          );

          this.validationHelper.test(element.XP.rewardValue,
            new this.validationHelper.ValidationExpressionBuilder()
              .MinValue(0, msg("Top_Dog_XP_Min", "XP field on Top Dog levels must be positive numbers."))
              .DigitOnly(msg("Top_Dog_XP_Invalid", "XP field on Top Dog levels must be valid numbers."))
              .WholeNumberOnly(msg("Top_Dog_XP_Whole_Number", "XP field on Top Dog levels must be whole numbers."))
              .Build()
          );

          this.validationHelper.test(element.Badge.rewardValue,
            new this.validationHelper.ValidationExpressionBuilder()
              .MinValue(0, msg("Top_Dog_Badge_Min", "Badge field on Top Dog levels must be positive numbers."))
              .DigitOnly(msg("Top_Dog_Badge_Invalid", "Badge field on Top Dog levels must be valid numbers."))
              .WholeNumberOnly(msg("Top_Dog_Badge_Whole_Number", "Badge field on Top Dog levels must be whole numbers."))
              .Build()
          );
        });

        var count = 0;
        game.TopDogRewards.forEach(element => {
          count++;
          if ((element.Coins.rewardValue == "0" || element.Coins.rewardValue == null) &&
            (element.XP.rewardValue == "0" || element.XP.rewardValue == null) &&
            (element.Badge.rewardValue == "0" || element.Badge.rewardValue == null))
            this.validationHelper.addValidationError(msg("No_Reward_On_Level", "No reward found on level") + " " + (count).toString(), null);
        });
      }

    } //End Top Dog validation              

    else if (game.underlyingRule.GameType == 3) { //Bullseye
      if (game.BullseyeRewards == null)
        this.validationHelper.addValidationError(msg("Bullseye_No_Component", "No Bullseye section found for this Bullseye game."), true);
      else {
        var br = game.BullseyeRewards;
        for (let i = 0; i < br.length; i++) {
          this.validationHelper.test(br[i].Coins.rewardValue,
            new this.validationHelper.ValidationExpressionBuilder()
              .MinValue(0, msg("Bullseye_Coins_Min", "Coin Reward on Bullseye levels must be positive numbers."))
              .MaxValue(9999999, msg("Bullseye_Coins_Max", "Coin Reward field on Bullseye levels must contain 7 digits or fewer."))
              .DigitOnly(msg("Bullseye_Coins_Invalid", "Coin Reward on Bullseye levels must be valid numbers."))
              .WholeNumberOnly(msg("Bullseye_Coins_Whole_Number", "Coin Reward on Bullseye levels must be whole numbers."))
              .Build()
          );

          this.validationHelper.test(br[i].XP.rewardValue,
            new this.validationHelper.ValidationExpressionBuilder()
              .MinValue(0, msg("Bullseye_XP_Min", "XP field on Bullseye levels must be positive numbers."))
              .DigitOnly(msg("Bullseye_XP_Invalid", "XP field on Bullseye levels must be valid numbers."))
              .WholeNumberOnly(msg("Bullseye_XP_Whole_Number", "XP field on Bullseye levels must be whole numbers."))
              .Build()
          );

          this.validationHelper.test(br[i].Badge.rewardValue,
            new this.validationHelper.ValidationExpressionBuilder()
              .MinValue(0, msg("Bullseye_Badge_Min", "Badge field on Bullseye levels must be positive numbers."))
              .DigitOnly(msg("Bullseye_Badge_Invalid", "Badge field on Bullseye levels must be valid numbers."))
              .WholeNumberOnly(msg("Bullseye_Badge_Whole_Number", "Badge field on Bullseye levels must be whole numbers."))
              .Build()
          );
        }

        //check that at least one reward is available per level                    
        for (let i = 0; i < br.length; i++) {
          if ((br[i].Coins.rewardValue == "0" || br[i].Coins.rewardValue == null) &&
            (br[i].XP.rewardValue == "0" || br[i].XP.rewardValue == null) &&
            (br[i].Badge.rewardValue == "0" || br[i].Badge.rewardValue == null))
            this.validationHelper.addValidationError(msg("No_Reward_On_Level", "No reward found on level") + " " + (i + 1).toString(), null);
        }
      }
    } //End Bullseye validation 

    else if (game.underlyingRule.GameType == 5) { //Milestone
      if (game.MilestoneRewards == null)
        this.validationHelper.addValidationError(msg("Milestone_No_Component", "No Milestone section found for this Milestone game."), true);
      else {
        var ms = game.MilestoneRewards;
        for (let i = 0; i < ms.length; i++) {
          this.validationHelper.test(ms[i].Coins.rewardValue,
            new this.validationHelper.ValidationExpressionBuilder()
              .MinValue(0, msg("Milestone_Coins_Min", "Coin Reward on Milestone levels must be positive numbers."))
              .MaxValue(9999999, msg("Milestone_Coins_Max", "Coin Reward field on Milestone levels must contain 7 digits or fewer."))
              .DigitOnly(msg("Milestone_Coins_Invalid", "Coin Reward on Milestone levels must be valid numbers."))
              .WholeNumberOnly(msg("Milestone_Coins_Whole_Number", "Coins Reward on Milestone levels must be whole numbers."))
              .Build()
          );

          this.validationHelper.test(ms[i].XP.rewardValue,
            new this.validationHelper.ValidationExpressionBuilder()
              .MinValue(0, msg("Milestone_XP_Min", "XP field on Milestone levels must be positive numbers."))
              .DigitOnly(msg("Milestone_XP_Invalid", "XP field on Milestone levels must be valid numbers."))
              .WholeNumberOnly(msg("Milestone_XP_Whole_Number", "XP field on Milestone levels must be whole numbers."))
              .Build()
          );

          this.validationHelper.test(ms[i].Badge.rewardValue,
            new this.validationHelper.ValidationExpressionBuilder()
              .MinValue(0, msg("Milestone_Badge_Min", "Badge field on Milestone levels must be positive numbers."))
              .DigitOnly(msg("Milestone_Badge_Invalid", "Badge field on Milestone levels must be valid numbers."))
              .WholeNumberOnly(msg("Milestone_Badge_Whole_Number", "Badge field on Milestone levels must be whole numbers."))
              .Build()
          );
        }

        //check that at least one reward is available per level                    
        for (let i = 0; i < ms.length; i++) {
          if ((ms[i].Coins.rewardValue == "0" || ms[i].Coins.rewardValue == null) &&
            (ms[i].XP.rewardValue == "0" || ms[i].XP.rewardValue == null) &&
            (ms[i].Badge.rewardValue == "0" || ms[i].Badge.rewardValue == null))
            this.validationHelper.addValidationError(msg("No_Reward_On_Level", "No reward found on level") + " " + (i + 1).toString(), null);
        }
      }
    } //End Milestone validation

    else if (game.underlyingRule.GameType == 6) { //Connect3
      if (game.Connect3Rewards.ThreeInRow == null)
        this.validationHelper.addValidationError(msg("Connect3_No_Component", "No Connect 3 section found for this Connect 3 game."), true);
      else {
        var c3r = game.Connect3Rewards.ThreeInRow;
        this.validationHelper.test(c3r.coins,
          new this.validationHelper.ValidationExpressionBuilder()
            .MinValue(0, msg("Connect3_Coins_Min", "Coin Reward on Connect 3 must be positive numbers."))
            .MaxValue(9999999, msg("Connect3_Coins_Max", "Reward field on Connect 3 must contain 7 digits or fewer."))
            .DigitOnly(msg("Connect3_Coins_Invalid", "Coin Reward on Connect 3 must be valid numbers."))
            .WholeNumberOnly(msg("Connect3_Coins_Whole_Number", "Coins Reward on Connect 3 must be whole numbers."))
            .Build()
        );

        this.validationHelper.test(c3r.xp,
          new this.validationHelper.ValidationExpressionBuilder()
            .MinValue(0, msg("Connect3_XP_Min", "XP field on Connect 3 must be positive numbers."))
            .DigitOnly(msg("Connect3_XP_Invalid", "XP field on Connect 3 must be valid numbers."))
            .WholeNumberOnly(msg("Connect3_XP_Whole_Number", "XP field on Connect 3 must be whole numbers."))
            .Build()
        );

        this.validationHelper.test(c3r.badge,
          new this.validationHelper.ValidationExpressionBuilder()
            .MinValue(0, msg("Connect3_Badge_Min", "Badge field on Connect 3 must be positive numbers."))
            .DigitOnly(msg("Connect3_Badge_Invalid", "Badge field on Connect 3 must be valid numbers."))
            .WholeNumberOnly(msg("Connect3_Badge_Whole_Number", "Badge field on Connect 3 must be whole numbers."))
            .Build()
        );

        //check that at least one reward is available per level
        if ((c3r.coins == "0" || c3r.coins == null) &&
          (c3r.xp == "0" || c3r.xp == null) &&
          (c3r.badge == "0" || c3r.badge == null))
          this.validationHelper.addValidationError(msg("No_Reward_On_Level", "No reward found on level"), null);
      }
    } //End Connect3 validation

    else if (game.underlyingRule.GameType == 7) { //Blackout
      if (game.Connect3Rewards.Blackout == null)
        this.validationHelper.addValidationError(msg("Connect_all_No_Component", "No Connect all section found for this Connect All game."), true);
      else {
        var c3r = game.Connect3Rewards.Blackout;
        this.validationHelper.test(c3r.coins,
          new this.validationHelper.ValidationExpressionBuilder()
            .MinValue(0, msg("Connect_all_Coins_Min", "Coin Reward on Connect all must be positive numbers."))
            .MaxValue(9999999, msg("Connect_all_Coins_Max", "Coin Reward on Connect all must contain 7 digits or fewer."))
            .DigitOnly(msg("Connect_all_Coins_Invalid", "Coin Reward on Connect all must be valid numbers."))
            .WholeNumberOnly(msg("Connect_all_Coins_Whole_Number", "Coin Reward on Connect all must be whole numbers."))
            .Build()
        );

        this.validationHelper.test(c3r.xp,
          new this.validationHelper.ValidationExpressionBuilder()
            .MinValue(0, msg("Connect_all_XP_Min", "XP field on Connect all must be positive numbers."))
            .DigitOnly(msg("Connect_all_XP_Invalid", "XP field on Connect all must be valid numbers."))
            .WholeNumberOnly(msg("Connect_all_XP_Whole_Number", "XP field on Connect all must be whole numbers."))
            .Build()
        );

        this.validationHelper.test(c3r.badge,
          new this.validationHelper.ValidationExpressionBuilder()
            .MinValue(0, msg("Connect_all_Badge_Min", "Badge field on Connect all must be positive numbers."))
            .DigitOnly(msg("Connect_all_Badge_Invalid", "Badge field on Connect all must be valid numbers."))
            .WholeNumberOnly(msg("Connect_all_Badge_Whole_Number", "Badge field on Connect all must be whole numbers."))
            .Build()
        );

        //check that at least one reward is available per level
        if ((c3r.coins == "0" || c3r.coins == null) &&
          (c3r.xp == "0" || c3r.xp == null) &&
          (c3r.badge == "0" || c3r.badge == null))
          this.validationHelper.addValidationError(msg("No_Reward_On_Level", "No reward found on level"), null);
      }
    } //End Blackout validation 

    else if (game.underlyingRule.GameType == 8) { //Top Team
      if (game.Eligibility.AssignedGroups.emp && game.Eligibility.AssignedGroups.emp.length < 2) {
        this.validationHelper.addValidationError(
          msg("Top_Team_Required_Team_Quantity", "At least two teams are required as minimum to create the game"),
          true
        );
      }
      else {
        game.TopDogRewards.forEach(element => {
          this.validationHelper.test(element.Coins.rewardValue,
            new this.validationHelper.ValidationExpressionBuilder()
              .MinValue(0, msg("Top_Team_Coins_Min", "Coin Reward on Top Team levels must be positive numbers."))
              .MaxValue(9999999, msg("Top_Team_Coins_Max", "Coin Reward on the Top Team level must contain 7 digits or fewer."))
              .DigitOnly(msg("Top_Team_Coins_Invalid", "Coin Reward on Top Team levels must be valid numbers."))
              .WholeNumberOnly(msg("Top_Team_Coins_Whole_Number", "Coin Reward on Top Team levels must be whole numbers."))
              .Build()
          );

          this.validationHelper.test(element.XP.rewardValue,
            new this.validationHelper.ValidationExpressionBuilder()
              .MinValue(0, msg("Top_Teamg_XP_Min", "XP field on Top Team levels must be positive numbers."))
              .DigitOnly(msg("Top_Team_XP_Invalid", "XP field on Top Team levels must be valid numbers."))
              .WholeNumberOnly(msg("Top_Team_XP_Whole_Number", "XP field on Top Team levels must be whole numbers."))
              .Build()
          );

          this.validationHelper.test(element.Badge.rewardValue,
            new this.validationHelper.ValidationExpressionBuilder()
              .MinValue(0, msg("Top_Team_Badge_Min", "Badge field on Top Team levels must be positive numbers."))
              .DigitOnly(msg("Top_Team_Badge_Invalid", "Badge field on Top Team levels must be valid numbers."))
              .WholeNumberOnly(msg("Top_Team_Badge_Whole_Number", "Badge field on Top Team levels must be whole numbers."))
              .Build()
          );
        });

        var count = 0;
        game.TopDogRewards.forEach(element => {
          count++;
          if ((element.Coins.rewardValue == "0" || element.Coins.rewardValue == null) &&
            (element.XP.rewardValue == "0" || element.XP.rewardValue == null) &&
            (element.Badge.rewardValue == "0" || element.Badge.rewardValue == null))
            this.validationHelper.addValidationError(msg("No_Reward_On_Level", "No reward found on level") + " " + (count).toString(), null);
        });
      }
    } //End Top Team validation

    else if (game.underlyingRule.GameType == 9) { //Raffle
      if (game.RaffleRewards == null) {
        this.validationHelper.addValidationError(msg("Raffle_No_Component", "No Raffle section found for this Raffle game."), true);
      }
      else {
        game.RaffleRewards.forEach(element => {
          if (element.isSystemReward) {
            this.validationHelper.test(element.Coins.rewardValue,
              new this.validationHelper.ValidationExpressionBuilder()
                .MinValue(0, msg("Raffle_Coins_Min", "Coins Reward on Raffle levels must be positive numbers."))
                .MaxValue(9999999, msg("Raffle_Coins_Max", "Coin Reward on Raffle levels must contain 7 digits or fewer."))
                .DigitOnly(msg("Raffle_Coins_Invalid", "Coins Reward on Raffle levels must be valid numbers."))
                .WholeNumberOnly(msg("Raffle_Coins_Whole_Number", "Coins Reward on Raffle levels must be whole numbers."))
                .Build()
            );

            this.validationHelper.test(element.XP.rewardValue,
              new this.validationHelper.ValidationExpressionBuilder()
                .MinValue(0, msg("Raffle_XP_Min", "XP field on Raffle levels must be positive numbers."))
                .DigitOnly(msg("Raffle_XP_Invalid", "XP field on Raffle levels must be valid numbers."))
                .WholeNumberOnly(msg("Raffle_XP_Whole_Number", "XP field on Raffle levels must be whole numbers."))
                .Build()
            );
          }
          else {
            this.validationHelper.test(element.Custom.rewardText, { Required: msg("Custom_Prize_Required", "You haven't entered a name for the reward.") });

            if ((/[\\/!+<>?#&,%]/).test(element.Custom.rewardText)) {
              this.validationHelper.addValidationError(msg("Game_Invalid_Characters", "The following characters are not permitted: \ / ! + < > ? # & , %"), true);
            }
          }
        });

        var count = 0;
        game.RaffleRewards.forEach(element => {
          count++;
          const isInvalidSystemReward = !!element.isSystemReward && (element.Coins.rewardValue == "0" || element.Coins.rewardValue == null) &&
            (element.XP.rewardValue == "0" || element.XP.rewardValue == null);
          const isInvalidCustomReward = !element.isSystemReward && !element.Custom.rewardText;
          if (isInvalidSystemReward || isInvalidCustomReward) {
            this.validationHelper.addValidationError(msg("No_Reward_On_Level", "No reward found on level") + " " + (count).toString(), null);
          }
        });
      }
    } //End Raffle validation  

    else if (game.underlyingRule.GameType == 10) { //Brackets Tournament
      if (game.BracketsTournamentRewards == null) {
        this.validationHelper.addValidationError(msg("Brackets_No_Component", "No Brackets section found for this Brackets game."), true);
      }
      else {
        game.BracketsTournamentRewards.forEach(element => {
          if (element.isSystemReward) {
            this.validationHelper.test(element.Coins.rewardValue,
              new this.validationHelper.ValidationExpressionBuilder()
                .MinValue(0, msg("Brackets_Coins_Min", "Coins Reward on Brackets Tournament levels must be positive numbers."))
                .MaxValue(9999999, msg("Brackets_Coins_Max", "Coin Reward on Brackets levels must contain 7 digits or fewer."))
                .DigitOnly(msg("Brackets_Coins_Invalid", "Coins Reward on Brackets Tournament levels must be valid numbers."))
                .WholeNumberOnly(msg("Brackets_Coins_Whole_Number", "Coins Reward on Brackets Tournament levels must be whole numbers."))
                .Build()
            );

            this.validationHelper.test(element.XP.rewardValue,
              new this.validationHelper.ValidationExpressionBuilder()
                .MinValue(0, msg("Brackets_XP_Min", "XP field on Brackets Tournament levels must be positive numbers."))
                .DigitOnly(msg("Brackets_XP_Invalid", "XP field on Brackets Tournament levels must be valid numbers."))
                .WholeNumberOnly(msg("Brackets_XP_Whole_Number", "XP field on Brackets Tournament levels must be whole numbers."))
                .Build()
            );
          }
          else {
            this.validationHelper.test(element.Custom.rewardText, { Required: msg("Custom_Prize_Required", "You haven't entered a name for the reward.") });

            if ((/[\\/!+<>?#&,%]/).test(element.Custom.rewardText)) {
              this.validationHelper.addValidationError(msg("Game_Invalid_Characters", "The following characters are not permitted: \ / ! + < > ? # & , %"), true);
            }
          }
        });

        var count = 0;
        game.BracketsTournamentRewards.forEach(element => {
          count++;
          if ((element.Coins.rewardValue == "0" || element.Coins.rewardValue == null) &&
            (element.XP.rewardValue == "0" || element.XP.rewardValue == null) &&
            (element.Custom.rewardText == "" || element.Custom.rewardText == null))
            this.validationHelper.addValidationError(msg("No_Reward_On_Level", "No reward found on level") + " " + (count).toString(), null);
        });

        const rightSideGroups = game.BracketTournamentMatches.rightSide.flat(4).length;
        const leftSideGroups = game.BracketTournamentMatches.leftSide.flat(4).length;

        var totalOfParticipants = rightSideGroups + leftSideGroups;

        if (totalOfParticipants < this.gs.modified.item.BracketTournamentDetails.totalParticipants) {
          this.validationHelper.addValidationError(msg("Incomplete_Couples_Bracket_Tournament", "There are not enough participants, you must add more participants."), null);
        } else if (totalOfParticipants > this.gs.modified.item.BracketTournamentDetails.totalParticipants && !game.BracketTournamentDetails.GameStarted) {
          // Adjust the matches if this is a new version of the tournament
          let rightSide = [];
          let leftSide = [];

          for (let i = 0; i < game.BracketTournamentMatches.rightSide[0].length; i += 2) {
            const pairR = game.BracketTournamentMatches.rightSide[0].slice(i, i + 2);
            const pairL = game.BracketTournamentMatches.leftSide[0].slice(i, i + 2);

            rightSide.push(pairR);
            leftSide.push(pairL);
          }

          game.BracketTournamentMatches.rightSide = rightSide;
          game.BracketTournamentMatches.leftSide = leftSide;
        }
      }
    } //End Brackets Tournament validation  

    //Participants
    const hasNoParticipants = game.Eligibility.AssignedGroups.emp?.length == 0 && game.Eligibility.AssignedGroups.rec?.length == 0;
    if (
      (game.Eligibility == null ||
        game.Eligibility.AssignedGroups == null ||
        (game.Eligibility.AssignedGroups.length == 0 && !this.isCxone) ||
        hasNoParticipants) &&
      game.gameType !== 10
    ) {
      this.validationHelper.addValidationError(
        msg("No_Logins_Assigned", "No logins are assigned to be able to join this game."),
        true
      );
    }

    //Schedule
    if (game.underlyingRule.GameType != 10) {
      this.validationHelper.test(game.Schedule.IntervalType,
        new this.validationHelper.ValidationExpressionBuilder()
          .Required(msg("Schedule_Interval_Type_Required", "A value is required for the 'Repeat After Every' field in the schedule."))
          .Build()
      );
      this.validationHelper.test(game.Schedule.StartDate,
        new this.validationHelper.ValidationExpressionBuilder()
          .TestAs("DateTime")
          .Required(msg("Schedule_Start_Date_Required", "A start date is required to create a game."))
          .Build()
      );
      if (!game.Schedule.Ongoing) {
        this.validationHelper.test(game.Schedule.EndDate,
          new this.validationHelper.ValidationExpressionBuilder()
            .TestAs("DateTime")
            .Required(msg("Schedule_End_Date_Required", "An end date is required if this game is not going to run indefinitely (ongoing)."))
            .Build()
        );
      }
    } else {
      for (let i = 0; i < game.BracketTournamentRounds.length; i++) {
        let previous;
        let current;
            
        if (i > 0) {                        
          previous = game.BracketTournamentRounds[i-1].StartDate;
          current = game.BracketTournamentRounds[i].StartDate;
        }

        if (!game.BracketTournamentRounds[i].StartDate || (i > 0 && previous >= current) || moment(game.BracketTournamentRounds[i].EndDate).isBefore(moment())
            && (!game.BracketTournamentDetails.GameStarted || game.underlyingRule.IsCopy)
        ) {
          this.validationHelper.addValidationError(msg("Brackets_Schedule_Validate_Dates", "Please make sure to enter a date for each phase in chronological order."), true); 
          break;
        }
      }
    }

    if (game.Schedule.StartDate && game.Schedule.EndDate) {
      const mStart = moment(game.Schedule.StartDate);
      const mEnd = moment(game.Schedule.EndDate);
      const mToday = moment(); //Gets today date
      if (mStart.isSame(mToday, 'day') && !mStart.isBefore(mEnd)) { //We removed the validation for same-day start and end dates when set to a future date. However, if the start and end dates are set to today, the validation will still apply.
        this.validationHelper.addValidationError(msg("Schedule_Validate_Dates", "You have entered an invalid date, your game's start date should be before the end date."), true);
      }
    }
  };

  cancel(): void {
    this.cancelAddEdit.emit();
    this.saveInProgress = false;
    //These flags are being used only for CxOne for now.
      this.gamesService.isCancelAction = true;
      this.gamesService.isBackAction = false;
  }

  back(): void {
      this.gamesService.isBackAction = true;
      this.gamesService.isCancelAction = false;
    this.previousView.emit();
  }

  adjustDateTimeFields() {
    var game = this.gs.modified.item;

    if (game.underlyingRule.GameType != 10) {
      var timezoneOffsetMinutes = game.Schedule.StartDate.getTimezoneOffset();
      var setMinutes = game.Schedule.StartDate.getMinutes() - timezoneOffsetMinutes;
  
      game.Schedule.StartDate.setMinutes(setMinutes);
  
      if (game.Schedule.EndDate != null) {
        timezoneOffsetMinutes = game.Schedule.EndDate.getTimezoneOffset();
        setMinutes = game.Schedule.EndDate.getMinutes() - timezoneOffsetMinutes;
  
        game.Schedule.EndDate.setMinutes(setMinutes);
      }
    } else {
      game.BracketTournamentRounds.forEach(round => {
        var timezoneOffsetMinutes = round.StartDate.getTimezoneOffset();
        var setMinutes = round.StartDate.getMinutes() - timezoneOffsetMinutes;

        round.StartDate.setMinutes(setMinutes);

        timezoneOffsetMinutes = round.EndDate.getTimezoneOffset();
        setMinutes = round.EndDate.getMinutes() - timezoneOffsetMinutes;
  
        round.EndDate.setMinutes(setMinutes);
      });

      game.Schedule.StartDate = game.BracketTournamentRounds[0].StartDate;
      game.Schedule.EndDate = game.BracketTournamentRounds[game.BracketTournamentRounds.length-1].EndDate;
    }
  }

  saveGame() {
    if (this.saveInProgress)
      return;

    this.saveInProgress = true;

    //Run validation before saving
    this.validateGame();
    if (this.validationHelper.succeeded) {
      var mode = this.gs.modified.item.underlyingRule.RuleID == 0 ? 'create' : 'edit';
      this.adjustDateTimeFields();

      let game = cloneDeep(this.gs.modified.item);
      const loadProducts = this.shouldReloadProducts(game);

      this.gamesService.saveGame(game, loadProducts).then((result: any) => {
        if (result != null && result.data != null && result.data.GameObject != null) {
          var eventArgs = {
            game: result.data,
            mode: mode
          }
          // update games list with new game avoid create duplicate games
          this.gs.games.push(result.data.GameObject);
          this.saveSuccess.emit(eventArgs);
        }
        this.saveInProgress = false;
      });
    } else {
      const message = this.validationHelper.messages.map(message => `<li>${message}</li>`).join('\n');

      if(this.isCxone) {
        const modalOptions: NgbModalOptions = {
          keyboard: false,
          backdrop: 'static',
          centered: true,
          windowClass: 'cxone-create-game-validation-modal'
        };

        this.customDialogService.showDialog(
          this.gamesService.getLocalizedMessage("Game_Validator_Header", "Warning"),
          "<ul class='errorBulletList'>" + message + "</ul>",
          13,
          '',
          this.gamesService.getLocalizedMessage("Ok", "Ok"),
          true,
          () => { this.saveInProgress = false; },
          () => { this.saveInProgress = false; },
          'cxone-create-game-validation-modal-style',
          true,
          modalOptions
        );
      } else {
        showConfirmDialog(
          "<ul class='errorBulletList'>" + message + "</ul>",
          [], this.gamesService.getValidationMessage("Game_Validation_Header", "Command Center - Game validation"), "error"
        );
        this.saveInProgress = false;
      }
      }
  };

  //Events
  private metricClickedHandler = (e: any) => {
    var metricDefinition = {
      metricID: e.mID,
      abbrev: e.mAbr,
      name: e.mName,
      prefix: e.mPX,
      suffix: e.mSX,
      conversionType: e.mCT,
      direction: e.mDir
    };

    var eventArgs = {
      metricDefinition: metricDefinition,
      source: this.metricSelectorComponentSource
    };

    $(document).trigger(new jQuery.Event("Event.Games.Setup.MetricClicked", eventArgs));
    $(document).off("metricClicked", this.metricClickedHandler);
    this.navigationService.showOverlay = false;
  }

  private shouldReloadProducts(game: any) {
    let isNewProduct = false;
    if (game.underlyingRule.GameType == 9) {
      game.RaffleRewards.forEach((reward) => {
        if (!reward.isSystemReward && reward.Custom.rewardValue == 0) {
          isNewProduct = true;
          return isNewProduct;
        }
      });
    }

    return isNewProduct;
  }

  getMetricKeyData(args) {
    if (args && args.options && !isNaN(args.options.maxMetrics)) {
      const metricKey = [args.options.maxMetrics, args.options.recGroupID, args.options.recGroupLevel].filter(v => !isNaN(v));
      return metricKey.join(',');
    }
    return '';
  }

  componentCompleted(args: any) {
    if (args != null && args.unlocks != null && args.currentStep != null) {
      switch (args.unlocks) {
        case 'next':
          this.gs.unlockComponent(args.currentStep + 1);
          break;
        case 'next2':
          this.gs.unlockComponent(args.currentStep + 1);
          this.gs.unlockComponent(args.currentStep + 2);
          break;
      }
    }

    if (args != null && args.currentStep != null) {
      this.gs.setComponentCompletionStatus(args.currentStep, true);
    }
    this.cdRef.detectChanges();
  }

  onMetricSelected(event) {
    this.metricClickedHandler(event);
  }

  handleRankingData(rankingData: any) {
    this.rankingData = rankingData;
  }
  
  getLocalizationString(key: string, defaultValue: string) {
    return this.cvLocalization.getCachedText("Admin", key, defaultValue);
  }

  setLoading(value: boolean) {
    setTimeout(() => {
      this.loading = value;
    });

    this.cdRef.detectChanges();
  }
  
  scrollToTop(): void {
    if (this.scrollableContent && this.scrollableContent.nativeElement) {
      this.scrollableContent.nativeElement.scrollTop = 0;
    }
  }
}
